<template>
    <div style="background-color: #fff;padding:16px 0 0px 16px; overflow: hidden;">
        <title_value v-for="i in items" :key="i.title" :title="i.title" :value="i.value.toString()" />
    </div>
</template>
<script>
import { queryVehicleBaseInfo } from "@/http/vehicle";
import title_value from "./title_value"
export default {
    props: {
        VID: {
            type: Number,
            default: 0
        }
    },
    watch: {
        VID() {
            this.getVehicleBaseInfo();
        }
    },
    components: {
        title_value
    },
    data() {
        return {
            items: [
                { title: this.$t("locateVehicle.VIN码"), value: "-" },
                { title: this.$t("locateVehicle.出厂编号"), value: "-" },
                { title: this.$t("locateVehicle.终端编号"), value: "-" },
                { title: this.$t("locateVehicle.车型"), value: "-" },
                { title: this.$t("locateVehicle.燃料类型"), value: "-" },
                { title: this.$t("locateVehicle.驾驶员"), value: "-" }
            ]
        }
    },
    methods: {
        getVehicleBaseInfo() {
            if (this.VID == 0) {
                return;
            }
            queryVehicleBaseInfo({ 'VID': this.VID, 'LanguageId': this.$store.getters.LanguageId }).then(res => {
                // console.log(res);
                this.items = [];
                if (res) {
                    this.items.push({ title: this.$t("locateVehicle.VIN码"), value: res.VINCode || "-" },);
                    this.items.push({ title: this.$t("locateVehicle.出厂编号"), value: res.ManufactureID || "-" },);
                    this.items.push({ title: this.$t("locateVehicle.终端编号"), value: res.DeviceNo || "-" },);
                    this.items.push({ title: this.$t("locateVehicle.车型"), value: res.VehicleModel || "-" },);
                    this.items.push({ title: this.$t("locateVehicle.燃料类型"), value: res.OilTypeID || "-" },);
                    this.items.push({ title: this.$t("locateVehicle.驾驶员"), value: res.DriverName || "-" },);
                }
            })
            //   queryVehicleNewEngineBaseInfo({'DeviceNo': '003812012498'}).then(res => {
            //     console.log(res);
            // })

        }
    },
    mounted() {

        this.getVehicleBaseInfo();
    }
}
</script>